<template>
  <div class="post-summary">
    <PostEditWeight ref="editWeight" @save="save" />
    <PostEditServiice ref="editService" @redirect="redirect" />

    <div class="post-summary__service">
      <img class="post-summary__logo" :src="data.logo" />
      <div>
        <div class="post-summary__name">{{ data.name }}</div>
        <div class="post-summary__meta">
          {{ ruleForm.height }} × {{ ruleForm.width }} × {{ ruleForm.length }} cm · {{ ruleForm.weight }} g
        </div>
      </div>
    </div>
    <div class="post-summary__values">
      <div class="post-summary__value">
        <span class="post-summary__label">Preço</span>
        <span class="post-summary__amount">{{ format(data.value) }}</span>
      </div>
      <div class="post-summary__value">
        <span class="post-summary__label">Valor segurado</span>
        <span class="post-summary__amount">{{ format(+form.valuedeclared) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import PostEditServiice from "./PostEditServiice.vue";
import PostEditWeight from "./PostEditWeight.vue";

export default {
  name: "PostHeader",
  data() {
    return {
      ruleForm: {
        weight: 0,
        length: 0,
        width: 0,
        height: 0,
      },
    };
  },
  props: ["form", "data"],
  methods: {
    setup(form, data) {
      console.log("form", form);
      this.ruleForm.weight = +form.weight;
      this.ruleForm.height = +form.height;
      this.ruleForm.width = +form.width;
      this.ruleForm.length = +form.length;
    },
    format(value) {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 }).format(
        value
      );
    },
    redirect() {
      console.log("emit header");
      this.$emit("redirect");
    },
    open(ref) {
      this.$refs[ref].setup(this.ruleForm);
    },
    save() {
      this.ruleForm = this.$refs.editWeight.ruleForm;
    },
  },
  components: { PostEditWeight, PostEditServiice },
};
</script>

<style scoped>
.post-summary {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px 32px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}
.post-summary__service {
  display: flex;
  align-items: center;
  gap: 14px;
}
.post-summary__logo {
  width: 64px;
  height: auto;
}
.post-summary__name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  line-height: 1.4;
}
.post-summary__meta {
  font-size: 13px;
  color: #909399;
  line-height: 1.6;
}
.post-summary__values {
  display: flex;
  gap: 32px;
}
.post-summary__label {
  display: block;
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
.post-summary__amount {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
</style>
